import dynamic from 'next/dynamic';
import SearchSpeaker from '../../../../components/SearchSpeaker';

const ContactForm = dynamic(() =>
  import(/* webpackChunkName: "pbScContactForm" */ '../../../../components/ContactForm')
);

const pageBuilderComponents = {
  'sc-contact-form': ContactForm,
  'search-speaker': SearchSpeaker
};

export default pageBuilderComponents;
